import type { Product as EsProduct } from "@bmi/elasticsearch-types";
import type { ProductReference } from "@bmi/elasticsearch-types";
import {
  type NestedProductReferences,
  nestedProductReferencesMapper
} from "../types";
import { queryElasticSearch } from "../../../utils/elasticSearch";
import { constructQueryForProductReferences } from "./esQueries";
import { transformProductReferences } from "./products";
import type { ESResponse } from "../../../types/elasticsearch";

const getNestedProducts = async (
  productReferences: ProductReference[],
  esIndexNameProduct?: string
) => {
  if (!esIndexNameProduct || !productReferences.length) {
    return;
  }

  const res: ESResponse<EsProduct> = await queryElasticSearch(
    constructQueryForProductReferences(productReferences),
    esIndexNameProduct
  );
  const hits = res.hits.hits.map((hit) => hit._source);
  return transformProductReferences<NestedProductReferences>(
    productReferences,
    hits,
    nestedProductReferencesMapper
  );
};

export default getNestedProducts;
